export default "__VITE_ASSET__X22mPU0q__"